export class RateLimitError extends Error {
  constructor(contactEmail) {
    super("rate_limited");
    this.name = "RateLimitError";
    this.contactEmail = contactEmail;
  }
}

export async function evaluateApp(description) {
  const res = await fetch("/api/feasibility", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ description }),
  });

  if (res.status === 429) {
    const data = await res.json().catch(() => ({}));
    throw new RateLimitError(data.contactEmail || "hello@weizhi.me");
  }
  if (!res.ok) throw new Error("Evaluation failed");

  const data = await res.json();
  return data.verdict;
}
